<template>
  <!--  products -->
<div class="modal fade" id="ProductModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content" style="background-color: rgb(238 241 249);padding: 1em;">
                <div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="productModalCloseBTN"></button>
                </div>
                <div class="modal-body">
                    <div class="sc-dkPtyc kHUHMT">
                        <div class="sc-cidCJl bSoxch" style="justify-content:center">
                            <div class="sc-cidCJl dFviLG item" @click="closePopup" v-for="item in list" :key="item.id" >
                                <router-link :to="{name:'Shops',params:{item:item.id}}" class="Anchor-sc-1hr8fj2-0 lgqjga" >
                                    <div class="sc-dkPtyc Cuisine__CuisineBox-sc-1ckezvm-0 dDLLQr jBCiuq" >
                                    <img :src="'https://radap.ir/'+item.img_url" style="height: 70% !important;width: auto;">
                                    <div class="sc-dkPtyc Cuisine__CuisineText-sc-1ckezvm-1 jjoKdG gavXvj" >
                                        <p class="sc-hKwCoD jgMDLg" >{{item.name}}</p>
                                    </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
        </div>
    </div>
</div>
</template>

<script setup>
import {ref} from 'vue'
let list = ref()
get_menu()
async function get_menu() {
    let response = await fetch('https://radap.ir/Backend/api/section/menu/category.php')
    let data = await response.json()
        list.value = data
}
function closePopup(){
    document.getElementById('productModalCloseBTN').click()
}
</script>

<style scoped>
.gJAAsL > * {
    margin: 0 var(--padding-size);
}
.kHUHMT {
    display: flex;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: column nowrap;
    flex: unset;
}
.gJAAsL > div > * {
    margin-bottom: 2rem;
}
.cHfjpL {
    margin-bottom: 1rem;
}

.auEpD {
    font-family: IRANSansMobile;
    font-weight: 700;
    /* font-size: 1rem; */
    font-size: .9rem;
    line-height: 1.5rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(83, 86, 92);
    text-align: initial;
}

p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
}
.gJAAsL {
    --padding-size: 2.5rem;
    /* padding: var(--padding-size) 0; */
}
.gJAAsL > div > * {
    margin-bottom: 2rem;
}

.bSoxch {
    box-sizing: border-box;
    width: calc(100%);
    /* margin: calc(-1rem); */
    display: flex;
    flex-wrap: wrap;
}
@media (min-width: 37.5em){

    .dFviLG {
        -webkit-box-flex: initial;
        flex-grow: initial;
        flex-basis: 33.3333%;
        max-width: 33.3333%;
        min-width: initial;
    }
}


    .dFviLG {
        -webkit-box-flex: initial;
        flex-grow: initial;
        flex-basis: 50%;
        max-width: 11em;
        min-width: initial;
    }

.dFviLG {
    box-sizing: border-box;
}
.bSoxch > * {
    padding: calc(.6rem);
}
.gJAAsL {
    --padding-size: 2.5rem;
    /* padding: var(--padding-size) 0; */
}
.lgqjga {
    text-decoration: none;
}
.jBCiuq {
    position: relative;
    height: 5.9375rem;
    padding: 0.1875rem;
    background-color: rgb(255, 255, 255);
    border: 1px solid rgb(255, 255, 255);
    border-radius: 0.75rem;
    box-shadow: rgb(58 61 66 / 6%) 0px 1px 0px, rgb(0 0 0 / 30%) 0px 8px 32px -16px;
    cursor: pointer;
    transition: all 200ms ease-in-out 0s;
}

.dDLLQr {
    display: flex;
    justify-content: center !important;
    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: initial;
    align-items: initial;
    flex-flow: row nowrap;
    flex: unset;
}
.jBCiuq > img {
    width: 50%;
    height: 50%;
    object-fit: cover;
    border-radius: inherit;
}

img {
    border-style: none;
}
a:-webkit-any-link {
    color: -webkit-link;
    cursor: pointer;
}
.gavXvj {
    position: absolute;
    right: 0px;
    bottom: 0px;
    padding: 0.25rem .2rem 0.25rem 0.2rem;
    background-color: inherit;
    border-top-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
    transition: all 200ms ease-in-out 0s;
}

.jjoKdG {
    display: flex;
    justify-content: center !important;

    -webkit-box-pack: initial;
    place-content: initial;
    -webkit-box-align: center;
    align-items: center;
    flex-flow: row nowrap;
    flex: unset;
    width: 100%;
    border-radius : 10px;
}

.jgMDLg {
    font-weight: 900;
    font-size: .85rem;
    line-height: 1.5rem;
    width: auto;
    height: auto;
    padding: 0px;
    margin: 0px;
    display: inline-block;
    color: rgb(58, 61, 66);
    text-align: initial;
    max-height: 22px;
    max-width: fit-content;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 108px;
    overflow: hidden;
    text-align: center;
}
.gavXvj > svg {
    transform: translateX(0px);
    transition: all 200ms ease-in-out 0s;
}

</style>